import React, { useEffect, useState } from "react";
import PageHeader from "../components/page-header";
import SideBar from "../components/side-bar";
import returnIcon from "../assets/img/return.svg"
import Xicon from "../assets/img/products/xicon.svg"
import usericon from "../assets/img/products/usericon.svg"
import "../assets/css/settings.css";
import Teammoadal from "../components/teammember/team_modal";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../utils/url";
import { TeammemberSection } from "../components/teammember/TeammemberSection";
import { hideLoader, showLoader } from "../components/loader";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SettingsHeader from "../components/settings/settings-header";
import ConfirmationModal from "../components/confirmation-modal";

export default function Teammembers({ setActivePage}) {
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const pro = useSelector(state => state?.proReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const planType = useSelector(state => state?.plantypeReducer);
    const isEligiblie = useSelector(state => state?.eligibilityReducer);
    const [showModalasd, setShowModalasd] = useState(false)
    const [email, setEmail] = useState("")
    const [teamMembers, setTeamMembers] = useState([])
    const username = localStorage.user;
    const history = useHistory()
    const dispatch = useDispatch();
    const {state}  = useLocation()
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null });

    // useEffect(() => {
    //     if (!pro) {
    //         setShowModalasd(true);
    //     }else if(!isEligiblie){
    //         setShowModalasd(true);
    //     }else {
    //         setShowModalasd(false);
    //         getdata()
    //     }
    // }, [pro,planType]);

    function handlesave(e) {
        showLoader()
        let errorList = [];
        e.preventDefault()
        const api = apiUrl + `/settings/team-members/create`;
        var form_data = new FormData();
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        form_data.append("email", email);
        form_data.append("project", slug);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: form_data
        }
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code === 200) {
                    toast.success(response.status_message)
                    getdata()
                    setEmail("")
                    // hideLoader()
                }
                else {
                    response?.errors?.email?.map((val) => errorList?.push(val));
                    response?.errors?.member?.map((val) => errorList?.push(val));
                    if (errorList.length !== 0) {
                        errorList?.map((err) => {
                            return (
                                toast.error(err)
                            );
                        });
                    }
                    else {
                        toast.error(response?.status_message)
                    }
                    hideLoader()
                }

            }).catch((err) => {
                toast.error(err)
            })
    }
    function getdata() {
        let errorList = [];
        showLoader()
        if (slug) {
            const api = apiUrl + `/settings/team-members/get/${slug}`;
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const setOptions = {
                method: "GET",
                headers: myHeaders,
            };

            fetch(api, setOptions).then(async (res) => {
                // 
// console.log(res.json());
                const response = await res.json();
                if (response.status_code === 200) {
                    setTeamMembers(response.data)
                    hideLoader()
                }
                else {
                    response?.errors?.project?.map((val) => errorList?.push(val));
                    if (errorList.length !== 0) {
                        errorList?.map((err) => {
                            if (err == "Invalid Project") {
                                history.push("/dashboard")
                                toast.error(err)
                            }
                            else {
                                toast.error(err)
                            }
                        });
                    }
                    else {
                        toast.error(response?.status_message)
                    }
                    hideLoader()
                }
            })
                .catch((error) => {
                    toast.error(error)
                    hideLoader()
                    // console.error("Error:", error);
                });
        }
    }
    function removedata(id) {
        showLoader()
        
// console.log(id)
        const api = apiUrl + `/settings/team-members/delete/${id}`;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        };

        fetch(api, setOptions
        ).then(async (res) => {
            // 
// console.log(res.json());
            const response = await res.json();
            
// console.log("Deleted", response)
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            if (response?.status_code === 200) {
                if (response?.data?.action != "back to dashboard") getdata()
                else {
                    history.push("/dashboard")
                    toast.success(response.status_message)
                }
            }
            else {
                toast.error(response.status_message)
                hideLoader()
            }
        })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
    const splitName = (split_name) => {
        
// console.log(split_name)
        const number_of_spaces = split_name?.length > 1 ? [split_name[0], split_name[split_name?.length - 2], split_name[split_name?.length - 1]].toString().split(",").length : split_name?.length;

        let first_char;
        let sec_char;
        let space;
        if (number_of_spaces) {
            if (number_of_spaces == 1) {
                first_char = split_name.slice(0, 1)
                sec_char = split_name.slice(1, 2)
            }
            else if (number_of_spaces == 2) {
                space = split_name.indexOf(" ");
                first_char = split_name.slice(0, 1)
                sec_char = split_name.slice(space + 1, space + 2)
            }
            else if (number_of_spaces == 3) {
                space = split_name.lastIndexOf(" ");
                first_char = split_name.slice(0, 1)
                sec_char = split_name.slice(space + number_of_spaces - 2, space + number_of_spaces - 1)
            }
            else{
                space = username.lastIndexOf(" ");
                first_char = username.slice(0, 1)
                sec_char = username.slice(space + number_of_spaces - 2, space + number_of_spaces - 1)
            }
            return (first_char + sec_char).toUpperCase()
        }
        else return ""
    };
    useEffect(()=>{
        if (slug) {
            getdata()
        }
    },[slug])
    const upgradeHandleClick = (e) => {
        e.preventDefault();
        // $(".upgrade-main-btn").click();
        history.push(basepath + "/settings")
        // dispatch({ type: "SET_UPGRADE_MODAL", payload: { isPro: false, open: true } });
        // setShowModalasd(false);
    }
    const resendInvite = (id) => {
        showLoader()
        
        // console.log(id)
                const api = apiUrl + `/settings/team-members/resend-invite/${id}`;
                var myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
                const setOptions = {
                    method: "GET",
                    headers: myHeaders,
                };
        
                fetch(api, setOptions
                ).then(async (res) => {
                    // 
        // console.log(res.json());
                    const response = await res.json();
                    
        // console.log("Deleted", response)
                    if (response?.status_code === 200) {
                        hideLoader()
                        toast.success(response.status_message)
                    }
                    else {
                        toast.error(response.status_message)
                        hideLoader()
                    }
                })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
    };
    return (
        <div className="up-cont-u">
                <section className="settings-section-main">
                <SettingsHeader page={"Team"} secondName={'Team'} activePage={'team'} description={'Collaborate with your team members on GenPage'}/>                
                        <form onSubmit={handlesave} className="form-inline mt-20px">
                            <div>
                                <div className="fs-14px font-weight-500">
                                    Invite your team
                                </div>
                                <div className="account-form d-flex align-items-center gap-2 mt-10px">
                                    <input
                                        type="email"
                                        minLength={1}
                                        className="form-control"
                                        placeholder="Enter teammate email address"
                                        value={email}
                                        onChange={(a) => setEmail(a.target.value)}
                                    />
                                <button
                                    type="submit"
                                    className="add-member-btn text-nowrap"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
                                        <path d="M7.5 8.63889H4.575C3.66788 8.63889 3.21433 8.63889 2.84526 8.74414C2.0143 8.98113 1.36403 9.5925 1.11196 10.3737C1 10.7207 1 11.1472 1 12M10.1 10.1667L11.4 11.3889L14 8.94444M9.125 3.75C9.125 5.26878 7.81543 6.5 6.2 6.5C4.58457 6.5 3.275 5.26878 3.275 3.75C3.275 2.23122 4.58457 1 6.2 1C7.81543 1 9.125 2.23122 9.125 3.75Z" stroke="#183C81" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Add
                                </button>
                                </div>
                            </div>
                            <div>
                            </div>
                        </form>
                        <div className="fs-14px font-weight-500 mt-20px">
                            Manage your team
                        </div>
                        <div className="setting-body-main mt-10px">
                        <div className="team-list-container">
                            {teamMembers && <div div className="team-list" >
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <span className="team-members-icon">{teamMembers?.owner?.charAt(0)}</span>
                                    <span className="team-member-name">{teamMembers?.owner}</span>
                                    <span className="team-member-name">{teamMembers?.owner_email}</span>
                                    <div style={{color: "#213B7C"}} className="ms-0 yearly-discount-badge">
                                        <span className="me-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                                                <path d="M3.025 6.325L3.37801 7.03101C3.49748 7.26995 3.55721 7.38942 3.63701 7.49295C3.70783 7.58482 3.79018 7.66717 3.88205 7.73799C3.98558 7.81779 4.10505 7.87752 4.34399 7.99699L5.05 8.35L4.34399 8.70301C4.10505 8.82248 3.98558 8.88221 3.88205 8.96201C3.79018 9.03283 3.70783 9.11518 3.63701 9.20705C3.55721 9.31058 3.49748 9.43005 3.37801 9.66899L3.025 10.375L2.67199 9.66899C2.55252 9.43005 2.49279 9.31058 2.41299 9.20705C2.34217 9.11518 2.25982 9.03283 2.16795 8.96201C2.06442 8.88221 1.94495 8.82248 1.70601 8.70301L1 8.35L1.70601 7.99699C1.94495 7.87752 2.06442 7.81779 2.16795 7.73799C2.25982 7.66717 2.34217 7.58482 2.41299 7.49295C2.49279 7.38942 2.55252 7.26995 2.67199 7.03101L3.025 6.325Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.85 1.375L7.38038 2.75399C7.50729 3.08394 7.57074 3.24892 7.66941 3.38769C7.75686 3.51068 7.86432 3.61814 7.98731 3.70559C8.12608 3.80426 8.29106 3.86771 8.62101 3.99462L10 4.525L8.62101 5.05538C8.29106 5.18229 8.12608 5.24574 7.98731 5.34441C7.86432 5.43186 7.75686 5.53932 7.66941 5.66231C7.57074 5.80108 7.50729 5.96606 7.38038 6.29601L6.85 7.675L6.31962 6.29601C6.19271 5.96606 6.12926 5.80108 6.03059 5.66231C5.94314 5.53932 5.83568 5.43186 5.71269 5.34441C5.57392 5.24574 5.40894 5.18229 5.07899 5.05538L3.7 4.525L5.07899 3.99462C5.40894 3.86771 5.57392 3.80426 5.71269 3.70559C5.83568 3.61814 5.94314 3.51068 6.03059 3.38769C6.12926 3.24892 6.19271 3.08394 6.31962 2.75399L6.85 1.375Z" stroke="#213B7C" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        Owner
                                    </div>
                                </div>
                            </div>}
                            {teamMembers?.owner && teamMembers?.team_members?.map((member, i) => {
                                return (
                                    <div key={i} className="team-list" >
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <span className="team-members-icon">{member?.user?.name?.charAt(0) ?? member?.email?.charAt(0)}</span>
                                            <span className="team-member-name">{member?.email}</span>
                                        </div>
                                        <div>
                                            {
                                            member?.member == 1 ?
                                            <button className="member-remove-btn" onClick={() =>  setconfirmationModalShow({
                                                show: true, text: <>Are you sure you want to delete the user {member?.email}? <br/><br/> This action cannot be undone, but you’ll be able to invite them again later if you change your mind.</> , id: member?.id, callBackTo: "delete", callbackFunction: removedata
                                            })}>
                                                <span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                        <path d="M9.17949 8.22222L12 11M12 8.22222L9.17949 11M6.64103 7.94444H4.10257C3.31532 7.94444 2.9217 7.94444 2.60141 8.04013C1.88026 8.25558 1.31592 8.81136 1.09716 9.52159C1 9.83703 1 10.2247 1 11M8.05128 3.5C8.05128 4.88071 6.91477 6 5.51282 6C4.11087 6 2.97436 4.88071 2.97436 3.5C2.97436 2.11929 4.11087 1 5.51282 1C6.91477 1 8.05128 2.11929 8.05128 3.5Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </span>
                                                <span>Remove from workspace</span>
                                            </button>
                                            :
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="fs-12" style={{color:"#213B7C"}}>
                                                    Pending
                                                </span>
                                                <button className="resend-invite-btn text-blue">
                                                    <span onClick={() => resendInvite(member?.id)}>Resend Invite</span>
                                                    <span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                                            <path d="M1 7L7 1M7 1H3M7 1V5" stroke="#1188FF" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </span>
                                                </button>
                                                <button className="delete-all-btn" onClick={() => setconfirmationModalShow({
                                                        show: true, title: "Delete User", text: <>Are you sure you want to delete the user "{member?.email}"? <br/><br/> This action cannot be undone, but you’ll be able to invite them again later if you change your mind.</> , id: member?.id, callBackTo: "delete", callbackFunction: removedata
                                                    })}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                            <path d="M8.77364 0.564453C9.54452 0.564453 10.1761 1.17108 10.2319 1.94053L10.2359 2.05151V3.53857H12.4293C12.8331 3.53857 13.1605 3.87146 13.1605 4.2821C13.1605 4.6634 12.8782 4.97767 12.5146 5.02062L12.4293 5.02562H12.3789L11.8418 12.6728C11.736 14.179 10.54 15.3569 9.07236 15.4313L8.92474 15.435H4.23572C2.75088 15.435 1.51038 14.3057 1.33282 12.8223L1.31862 12.6728L0.780849 5.02562H0.731137C0.327341 5.02562 0 4.69274 0 4.2821C0 3.90079 0.282235 3.58652 0.645858 3.54357L0.731137 3.53857H2.92455V2.05151C2.92455 1.26756 3.52104 0.625299 4.27767 0.568532L4.38682 0.564453H8.77364ZM10.9122 5.02562H2.24749L2.77719 12.5669C2.82639 13.2672 3.34705 13.8256 4.00996 13.9303L4.1217 13.9435L4.23572 13.948H8.92474C9.65355 13.948 10.2646 13.4038 10.3708 12.6822L10.3833 12.5669L10.9122 5.02562ZM5.11796 7.25621C5.49291 7.25621 5.80195 7.54324 5.84418 7.91303L5.84909 7.99974V10.9739C5.84909 11.3845 5.52175 11.7174 5.11796 11.7174C4.743 11.7174 4.43396 11.4304 4.39173 11.0606L4.38682 10.9739V7.99974C4.38682 7.5891 4.71416 7.25621 5.11796 7.25621ZM8.0425 7.25621C8.41745 7.25621 8.72649 7.54324 8.76873 7.91303L8.77364 7.99974V10.9739C8.77364 11.3845 8.4463 11.7174 8.0425 11.7174C7.66755 11.7174 7.35851 11.4304 7.31627 11.0606L7.31137 10.9739V7.99974C7.31137 7.5891 7.63871 7.25621 8.0425 7.25621ZM8.77364 2.05151H4.38682V3.53857H8.77364V2.05151Z" fill="#FF2020" />
                                                    </svg>
                                                </button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        </div>
                        {confirmationModalShow?.show && <ConfirmationModal confirmationModalShow={confirmationModalShow} setShow={setconfirmationModalShow} callback={confirmationModalShow?.callbackFunction} />}
                        {/* {showModalasd && <Teammoadal from={"team-settings"} showModal={showModalasd} setShowModal={setShowModalasd} setActivePage={setActivePage} upgradeHandleClick={upgradeHandleClick} heading={'Upgrade to add team members.'} text={'Team members is a Ultra feature. Upgrade to <br /> zaap Ultra to unlock this feature'} isUltra={true}/>} */}
                    </section>
        </div>
    )
}